import formatMoney from 'money-format-shopify';

(async () => {
  if (!customElements.get('product-form')) {
    const { Fancybox } = await import('@fancyapps/ui');
    
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.orderUpgrade = document.querySelector('[data-order-upgrade]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('button--loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const sectionsToFetch = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
          ...this.cartNotification.getSectionsToRender().map((section) => section.id),
        ];

        const formData = new FormData(this.form);
        this.revenue = this.form.querySelector('input[name="quantity"]').value * this.form.querySelector('input[name="price"]').value / 100;

        formData.append('sections', sectionsToFetch);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        this.config = config;

        // popup 1
        if (window.funnel_data && window.funnel_data.popup_1) {
          if (window.funnel_data.popup_1_ab) {
            if (window.funnel_popup_1_ab) {
              this.handleFunnel(this.form.querySelector('input[name="id"]').value);
            } else {
              this.handleDefaultATC();
            }
          } else {
            this.handleFunnel(this.form.querySelector('input[name="id"]').value);
          }
        } else {
          this.handleDefaultATC();
        }
      }

      /*
        Handle funnels
      */
      handleFunnel(id) {
        let default_funnel = window.funnel_data.default_funnel;
        let preffered_funnel = window.funnel_data.preffered_funnel;
        let funnelArr = window.funnel_data.funnels;
        let active_funnel = false;
        let funnel1Arr = [];
        let funnel1Meta = [];

        //console.log('looking for id', id);

        // find active funnels
        funnelArr.forEach((funnel) => {
          if (funnel.destination == 'popup1') {
            funnel.triggerVariantIds.forEach((variantId) => {
              let variant_id = variantId.split('ProductVariant/')[1];
              //console.log('check variant id', variant_id);
              if (variant_id == id) {
                funnel1Arr.push(funnel);
              }
            })
          }
        })

        //console.log('funnel1Arr', funnel1Arr);

        if (funnel1Arr.length > 0) {
          active_funnel = true;
        }

        if (active_funnel) {
          this.singular_funnel = '';
          // find preffered funnel
          funnel1Arr.forEach((funnel1) => {
            if (funnel1.funnelType == preffered_funnel) {
              this.singular_funnel = funnel1;
            }
          });

          if (this.singular_funnel == '') {
            // find default funnel
            funnel1Arr.forEach((funnel1) => {
              if (funnel1.funnelType == default_funnel) {
                this.singular_funnel = funnel1;
              }
            });
          }

          if (this.singular_funnel == '') {
            this.handleDefaultATC();
          } else {
            let destination = this.singular_funnel.destination;
            let funnelType = this.singular_funnel.funnelType;
            let popupParent = document.querySelector('[data-popup-destination="' + destination + '"]');
            if (popupParent && popupParent.querySelector('[data-popup-type="' + funnelType + '"]')) {
              let popupWrapper = popupParent.querySelector('[data-popup-type="' + funnelType + '"]');
              this.handleData(popupWrapper);
            }
          }

        } else {
          this.handleDefaultATC();
        }
      }

      /*
        Handle data
      */
      handleData(popupWrapper) {

        //console.log('works????', this.singular_funnel);
      
        // find funnel meta
        this.funnel_metadata = '';
        let funnel_id = this.singular_funnel.id;
        window.funnel_data.funnels_meta.forEach((funnel_meta) => {
          if (funnel_meta.funnel_id == funnel_id) {
            this.funnel_metadata = funnel_meta;
          } 
        });

        // if there is a funnel
        if (this.funnel_metadata !== '') {

          //console.log('this.singular', this.singular_funnel);

          // update discount
          let discount = this.singular_funnel.settings.variantA.discount;
          popupWrapper.querySelectorAll('[data-funnel-discount]').forEach((discountHtml) => {
            discountHtml.innerHTML = discount;
          });

          // update title
          //console.log('this.funnel_metadata', this.funnel_metadata);
          let upgradeProduct = this.funnel_metadata.upgrade_product.title;
          if (upgradeProduct == '') {
            upgradeProduct = this.singular_funnel.settings.variantA.quantity + 'x ' + document.querySelector('.product__title').innerHTML;
          }

          popupWrapper.querySelectorAll('[data-funnel-upgrade-title]').forEach((element) => {
            element.innerHTML = upgradeProduct;
          });

          // update image
          //console.log('this.singular_funnel', this.singular_funnel);
          let updateImage = this.singular_funnel.image;
          popupWrapper.querySelector('[data-funnel-upgrade-image]').src = updateImage;

          // old products
          let used_titles = [];
          let render_it = true;
          this.funnel_metadata.trigger_products.forEach((trigger_product, index) => {
            render_it = true;
            used_titles.forEach((title) => {
              if (title == trigger_product.title) {
                render_it = false
              }
            });
            if (render_it) {
              used_titles.push(trigger_product.title);
              if (index == 0) {
                popupWrapper.querySelectorAll('[data-old-products-title]').forEach((element) => {
                  element.innerHTML = trigger_product.title;
                });
              } else {
                popupWrapper.querySelectorAll('[data-old-products-title]').forEach((element) => {
                  element.innerHTML = element.innerHTML + ', ' + trigger_product.title;
                });
              }
            }
          });

          // prices
          let oldPrice = this.funnel_metadata.triggers_price / 100;
          let savings = oldPrice / 100 * discount;
          let newPrice = oldPrice - savings;
          if (this.singular_funnel.funnelType == 'replace') {
            oldPrice = this.funnel_metadata.upgrade_product.compare_at_price;
            newPrice = this.funnel_metadata.upgrade_product.price;
            savings = oldPrice - newPrice;
          }
          popupWrapper.querySelector('[data-funnel-old-price]').innerHTML = formatMoney(oldPrice.toFixed(2), '{{ amount }}');
          popupWrapper.querySelector('[data-funnel-new-price]').innerHTML = formatMoney(newPrice.toFixed(2), '{{ amount }}');
          popupWrapper.querySelector('[data-funnel-save-price]').innerHTML = formatMoney(savings.toFixed(2), '{{ amount }}');

          // variant selector
          if (this.singular_funnel.funnelType == 'replace') {

            let url = 'https://www.primeprometics.com/products/complete-makeover-bundle';
            fetch(url)
              .then((response) => response.text())
              .then((responseText) => {
                const html = responseText;
                let element = new DOMParser().parseFromString(html, 'text/html').querySelector('combined-bundle').innerHTML;
                popupWrapper.querySelector('[data-funnel-option-select]').innerHTML = element;
                popupWrapper.querySelector('[data-bundle-purchaser]').remove();
                this.handlePopup(popupWrapper);
              });

          } else {
            this.handlePopup(popupWrapper);
          }

        } else {
          this.handlePopup(popupWrapper);
        }

     }

      /*
        Handle popup
      */
      handlePopup(popupWrapper) {

        // adjust data
        new Fancybox(
          [
            {
              src: popupWrapper.innerHTML,
              type: "html",
            },
          ],
          {
            on: {
              done: (fancybox, slide) => {


                if (this.singular_funnel.funnelType == 'upsell') {
                  // update pre-selected option
                  if (document.querySelector('variant-radios input:checked')) {
                    let selectedOption = document.querySelector('variant-radios input:checked').value + ' + ' + document.querySelector('variant-radios input:checked').value;
                    slide.$content.querySelector('[data-funnel-selected-id]').querySelectorAll('option').forEach((option) => {
                      if (option.innerHTML == selectedOption) {
                        slide.$content.querySelector('[data-funnel-selected-id]').value = option.value;
                        slide.$content.querySelector('[data-funnel-selected-id]').dispatchEvent(new Event("change"));
                      }
                    });
                  }
                }

                let accept = slide.$content.querySelector('[data-funnel-accept]');
                let decline = slide.$content.querySelector('[data-funnel-decline]');
                slide.$content.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
                  variant.addEventListener('click', (e) => {
                    e.target.closest('[data-bundle-variant-group]').querySelector('.border-black').classList.remove('border-black');
                    if (e.target.src) {
                      e.target.closest('[data-bundle-variant]').classList.remove('border-black-50');
                      e.target.closest('[data-bundle-variant]').classList.add('border-black');
                    } else {
                      e.target.classList.add('border-black');
                      e.target.classList.remove('border-black-50');
                    }
                    let img = e.target.closest('[data-bundle-variant-group]').querySelector('.border-black img').src;
                    let color = e.target.closest('[data-bundle-variant-group]').querySelector('[data-bundle-variant].border-black').dataset.bundleVariantColor;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = color;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = img;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = img;
                  });
                });
                // decline -- close
                decline.addEventListener('click', (event) => {
                  fancybox.close();
                  this.handleDefaultATC();
                });
                // accept offer
                accept.addEventListener('click', (event) => {
                  let ids = [];

                  if (this.singular_funnel.funnelType == 'replace') {
                    ids = [];
                    slide.$content.querySelector('[data-funnel-option-select]').querySelectorAll('[data-bundle-variant-group]').forEach((variant) => {
                      ids.push(variant.querySelector('.border-black').dataset.bundleVariantId);
                    });
                  } else {
                    let option = slide.$content.querySelector('[data-funnel-selected-id]');
                    ids = option.querySelector('option:checked').value.split(',');
                  }
                  
                  this.items = [];
                  let object = {};
                  if (ids.length > 0) {


                    if (this.singular_funnel.funnelType == 'replace') {
                      ids.forEach((id) => {
                        let properties = {};
                        properties._promo_product = 'false';
                        properties._funnel = 'PDP';
                        properties._funnel_location = 'popup1';
                        properties._funnel_type = 'automatic';
                        properties._promo = false;
                        properties._promo_discount = this.singular_funnel.settings.variantA.discount;
                        properties._promo_discount_type = 'percentage';
                        properties.product_bundle = this.funnel_metadata.upgrade_product.title;
                        properties._product_bundle_discount = this.singular_funnel.settings.variantA.discount;
                        properties._product_bundle_image = this.funnel_metadata.upgrade_product.upgrade_image;
                        properties._product_bundle_name = this.funnel_metadata.upgrade_product.title;
                        properties._product_bundle_variant_id = this.funnel_metadata.upgrade_product.variant_id;
                        object = {};
                        object = {
                          quantity: 1,
                          id: parseInt(id),
                          properties
                        }
                        this.items.push(object);
                      });
                    } else {
                      ids.forEach((id) => {
                        let properties = {};
                        properties._promo_product = 'false';
                        properties._funnel = 'PDP';
                        properties._funnel_location = 'popup1';
                        properties._funnel_type = 'automatic';
                        properties._promo = false;
                        properties._promo_discount = this.singular_funnel.settings.variantA.discount;
                        properties._promo_discount_type = 'percentage';
                        properties._product_bundle = false;
                        properties._discount = true;
                        object = {};
                        object = {
                          quantity: 1,
                          id: parseInt(id),
                          properties
                        }
                        this.items.push(object);
                      });
                    }


                    const sectionsToFetch = [
                      ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
                      ...this.cartNotification.getSectionsToRender().map((section) => section.id),
                    ];  
          
                    let body = JSON.stringify({
                      items: this.items,
                      sections: sectionsToFetch,
                      sections_url: window.location.pathname
                    });
                    
                    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                      .then((response) => response.json())
                      .then((parsedState) => {
                        fancybox.close();
                        this.cartDrawer.renderContents(parsedState);
                        this.cartDrawer.open();
                        this.submitButton.classList.remove('button--loading');
                        this.submitButton.removeAttribute('disabled');
                      })
                      .catch((e) => {
                        console.error(e);
                      })
                  }
                });
              },
              shouldClose: (fancybox, eventName) => {
                // decline offer
                if (typeof eventName !== 'undefined') {
                  if (eventName.target) {
                    this.handleDefaultATC();
                  }
                }
              }
            },
            mainClass: 'funnel-popup'
          }
        );
      }

      /*
        Handle default add_to_cart
      */
      handleDefaultATC() {
        const submitButton = this.querySelector('[type="submit"]');

        let upgradeOrder = false;

        if (this.orderUpgrade) {
          let insurace_id = this.orderUpgrade.dataset.orderUpgradeInsurance || false;
          let insurance_active = this.orderUpgrade.dataset.orderUpgradeInsuranceActive;
          let giftCard_id = this.orderUpgrade.dataset.orderUpgradeGift || false;
          let giftCard_active = this.orderUpgrade.dataset.orderUpgradeGiftActive;
          this.items = [];
          let object = {};
          if (giftCard_id || insurace_id) {
            if (insurace_id && insurance_active == 'false') {
              let properties = {};
              properties._promo_product = 'false';
              properties._funnel = 'order upgrade';
              properties._funnel_location = 'pdp';
              properties._funnel_type = 'automatic';
              properties._promo = false;
              properties._discount = JSON.stringify({});
              object = {};
              object = {
                quantity: 1,
                id: parseInt(insurace_id),
                properties
              }
              this.items.push(object);
              upgradeOrder = true;
            }
            if (giftCard_id && giftCard_active == 'false') {
              let properties = {};
              properties._promo_product = 'true';
              properties._funnel = 'order upgrade';
              properties._funnel_location = 'pdp';
              properties._funnel_type = 'automatic';
              properties._promo = true;
              properties._discount = JSON.stringify({
                "discount": "true",
                "amount": 100,
                "type": "percent", 
                "label": "FREE GIFT",
                "combination": '',
                "cart_totals": 0
              });
              object = {};
              object = {
                quantity: 1,
                id: parseInt(giftCard_id),
                properties
              }
              this.items.push(object);
              upgradeOrder = true;
            }
            // add form item
            let quantity = this.form.querySelector('input[name="quantity"]').value;
            let id = this.form.querySelector('input[name="id"]').value;
            let properties = {};
            properties._promo_product = 'false';
            properties._funnel = 'PDP';
            properties._funnel_location = 'Main ATC';
            properties._funnel_type = 'manual';
            properties._promo = false;
            properties._discount = JSON.stringify({});
            object = {};
            object = {
              quantity: parseInt(quantity),
              id: parseInt(id),
              properties
            }
            this.items.push(object);
          }
        }

        if (document.querySelector('[data-order-upgrade-ab]')) {
          if (document.querySelector('[data-order-upgrade-ab]').dataset.orderUpgradeAb) {
            upgradeOrder = false;
          }
        }

        if (window.orderUpgrade) {
          upgradeOrder = window.orderUpgrade;
        }

        if (upgradeOrder && this.items.length > 0) {

          const sectionsToFetch = [
            ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
            ...this.cartNotification.getSectionsToRender().map((section) => section.id),
          ];  

          let body = JSON.stringify({
            items: this.items,
            sections: sectionsToFetch,
            sections_url: window.location.pathname
          });
      
          fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => response.json())
            .then((parsedState) => {
        
              if (parsedState.status == 422) {
                // When quantity error
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
                return;
              }
  
              window.parsedState = parsedState;
  
              this.cartDrawer.renderContents(parsedState);
  
              switch (submitButton.dataset.addToCartBehavior) {
                case 'open_cart_drawer':
                  // Set timeout to force animation. Because content is just updated with renderContents
                  setTimeout(() => {
                    this.cartDrawer.open();
                  });
                  break;
                case 'show_cart_notification':
                default:
                  this.cartNotification.setActiveElement(document.activeElement);
                  this.cartNotification.renderContents(parsedState);
              }
              
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove('button--loading');
              submitButton.removeAttribute('disabled');
              if (typeof _tfa !== 'undefined') {
                let saved_taboola_id = sessionStorage.getItem('taboola_id');
                if (saved_taboola_id === null) {
                  saved_taboola_id = 1463766;
                }
                if (typeof saved_taboola_id !== 'undefined' && saved_taboola_id !== 'undefined') {
                  _tfa.push({notify: 'event', name: 'add_to_cart', id: saved_taboola_id, revenue: this.revenue});
                }
              }
              if (typeof amzn !== 'undefined') {
                let data = window.parsedState;
                let amazonObj = {};
                amazonObj.value = data.final_line_price / 100;
                amazonObj.currencyCode = Shopify.currency.active;
                amazonObj.unitsSold = data.quantity;
                amazonObj.contentId = data.key;
                amazonObj.name = data.title;
                amzn("trackEvent", "AddToCart", amazonObj);
              }
              let pnktdata = window.parsedState;
              if (typeof pintrk !== 'undefined') {
                pintrk('track', 'addtocart', {value: this.revenue, order_quantity: pnktdata.quantity, currency: Shopify.currency.active, product_id: pnktdata.id});
              }
            });

        } else {
          fetch(`${routes.cart_add_url}`, this.config)
            .then((response) => response.json())
            .then((parsedState) => {
              if (parsedState.status == 422) {
                // When quantity error
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
                return;
              }

              localStorage.removeItem('refused_gifts');
  
              window.parsedState = parsedState;
  
              this.cartDrawer.renderContents(parsedState);
  
              switch (submitButton.dataset.addToCartBehavior) {
                case 'open_cart_drawer':
                  // Set timeout to force animation. Because content is just updated with renderContents
                  setTimeout(() => {
                    this.cartDrawer.open();
                  });
                  break;
                case 'show_cart_notification':
                default:
                  this.cartNotification.setActiveElement(document.activeElement);
                  this.cartNotification.renderContents(parsedState);
              }

            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove('button--loading');
              submitButton.removeAttribute('disabled');
              if (typeof _tfa !== 'undefined') {
                let saved_taboola_id = sessionStorage.getItem('taboola_id');
                if (saved_taboola_id === null) {
                  saved_taboola_id = 1463766;
                }
                if (typeof saved_taboola_id !== 'undefined' && saved_taboola_id !== 'undefined') {
                  _tfa.push({notify: 'event', name: 'add_to_cart', id: saved_taboola_id, revenue: this.revenue});
                }
              }
              if (typeof amzn !== 'undefined') {
                let data = window.parsedState;
                let amazonObj = {};
                amazonObj.value = data.final_line_price / 100;
                amazonObj.currencyCode = Shopify.currency.active;
                amazonObj.unitsSold = data.quantity;
                amazonObj.contentId = data.key;
                amazonObj.name = data.title;
                amzn("trackEvent", "AddToCart", amazonObj);
              }
              let pnktdata = window.parsedState;
              if (typeof pintrk !== 'undefined') {
                pintrk('track', 'addtocart', {value: this.revenue, order_quantity: pnktdata.quantity, currency: Shopify.currency.active, product_id: pnktdata.id});
              }
            });
        }

      }

    }

    window.ProductForm = ProductForm;
    customElements.define('product-form', ProductForm);
  }
})();
